import { useGetCommonInformationForMessage } from '@urbanx/agx.support.client';
import { AgxColumn } from '@urbanx/agx.ui-components2';
import LoadingState from 'components/loadingState/LoadingState';
import Panel from 'components/panel/Panel';
import { useMemo } from 'react';
import PoisonQueueCampaignInformation from './PoisonQueueCampaignInformation';
import PoisonQueueAgentInformation from './PoisonQueueAgentInformation';
import PoisonQueueAgencyInformation from './PoisonQueueAgencyInformation';
import PoisonQueueStaffInformation from './PoisonQueueStaffInformation';

const PoisonQueueMessageCommonInformation = ({ messageBody }: { messageBody?: string }) => {
  const { agentId, agencyId, campaignId, userId, parsed } = useMemo(() => {
    const response = {
      agentId: undefined,
      agencyId: undefined,
      campaignId: undefined,
      userId: undefined,
      parsed: false,
    };

    if (!messageBody) return response;

    const parsedData = JSON.parse(messageBody)?.data;

    if (!parsedData) return response;

    response.agencyId = parsedData.agencyId ?? parsedData.AgencyId;
    response.campaignId = parsedData.campaignId ?? parsedData.CampaignId;
    response.userId = parsedData.userId ?? parsedData.UserId;
    response.agentId = parsedData.agentId ?? parsedData.AgentId;

    response.parsed = true;

    console.log('resonse', response);

    return response;
  }, [messageBody]);

  const { data: commmonInformation, isPending: isCommonInformationPending } =
    useGetCommonInformationForMessage(agentId, agencyId, campaignId, userId, parsed);

  return (
    <Panel title="Common Information">
      {isCommonInformationPending && <LoadingState />}
      {!isCommonInformationPending && (
        <AgxColumn fill gap="spacing-4xl">
          <PoisonQueueCampaignInformation
            campaignInformation={commmonInformation?.campaignInformation}
          />
          <PoisonQueueAgentInformation agentInformation={commmonInformation?.agentInformation} />
          <PoisonQueueAgencyInformation agencyInformation={commmonInformation?.agencyInformation} />
          <PoisonQueueStaffInformation staffInformation={commmonInformation?.staffInformation} />
        </AgxColumn>
      )}
    </Panel>
  );
};

export default PoisonQueueMessageCommonInformation;
